import { faPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { FormComponent, FormComponentProps } from '../../../components/form';
import css from './crop-select.module.css';

export default function CropSelect(
  fields: () => FormComponent[],
  name: string,
  addFieldsText: string,
  title?: string,
  show?: boolean,
  showIcons: boolean = true
): FormComponent {
  return ({ ...rest }) => (
    <CropComponent
      fields={fields}
      name={name}
      addFieldsText={addFieldsText}
      title={title}
      show={show}
      showIcons={showIcons}
      {...rest}
    />
  );
}

export function CropComponent({
  fields,
  name,
  addFieldsText,
  title,
  show,
  showIcons,
  ...rest
}: FormComponentProps & {
  fields: () => FormComponent[];
  name: string;
  addFieldsText: string;
  title: string;
  show: boolean;
  showIcons: boolean;
}) {
  const [state, setState] = useState({
    count: 0,
    fields: {} as { [key: string]: FormComponent[] },
  });
  const [showFields, setShowFields] = useState(show);

  const addFields = useCallback(() => {
    setState((state) => {
      setShowFields(true);

      state.fields[0] = fields();
      return {
        ...state,
        fields: state.fields,
      };
    });
  }, [fields]);

  useEffect(() => {
    if (showFields) {
      addFields();
    }
  }, [showFields, addFields]);

  return (
    <div className={css['wrapper']}>
      {!showFields && showIcons && title && (
        <div className={css['add']}>
          <button type="button" onClick={() => addFields()}>
            <FontAwesomeIcon icon={faPlus} /> {addFieldsText}
          </button>
        </div>
      )}

      {showFields && (
        <div className={css['component']}>
          {title && (
            <div className={css['header']}>
              <h3 className={css['title']}>{title}</h3>

              {showIcons && (
                <button
                  className={css['close']}
                  type="button"
                  name="remove_field"
                  onClick={() => setShowFields(false)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
            </div>
          )}

          {Object.keys(state.fields).map((key) => (
            <fieldset
              data-key={key}
              key={name.concat('-', key)}
              className={css['fields']}
            >
              <div className={css['components']}>
                {state.fields[key].map((Child, index) => {
                  return (
                    <Child
                      key={name.concat('-', key, '-', index.toString())}
                      {...rest}
                    />
                  );
                })}
              </div>
            </fieldset>
          ))}
        </div>
      )}
    </div>
  );
}
